import { Component, HostListener, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { CustomerDashboardModel } from 'src/app/models/customer/customerDashboard.model';
import { formatDate } from '@angular/common';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-customer-dashboard',
  templateUrl: './customer-dashboard.component.html',
  styleUrls: ['./customer-dashboard.component.scss']
})


export class CustomerDashboardComponent implements OnInit {
    isLoading: boolean = false;
    tankUsageForm!: FormGroup;
    tankHistoryForm!: FormGroup;
    tankSelectForm!: FormGroup;
    innerWidth: number | undefined;
    isScreenSmall: boolean = false;
    isScreenXSmall: boolean = false;
    showLegend: boolean = false;
    custId?: number;
    customerDashboard: Observable<CustomerDashboardModel> [] | undefined;
    customerTanks: any;
    selectedTank: any;
    selectedTankId: 0 | undefined;
    isGallons:boolean = true;
    isFahrenheit: boolean = true;
    propaneLevelChartData: any;
    usageLevelChartData: any;
    propaneUsageChartData: any;
    propaneUsageChartLabels: any;
    historyLevelChartData: any;
    historyLevelChartLabels: any;
    showTankSelect: boolean = false;
    customerTanksSelect$: any;
    selectedOption: any;
    dropdownOpen = false;
    chartData: [] = [];
    optionsTheme = 'dark-options';
    startDate: NgbDateStruct = { year: 1900, month: 1, day: 1 };


@HostListener('window:resize', ['$event'])
onResize(event: any) {
  this.innerWidth = window.innerWidth;
  if (this.innerWidth < 770) {
    this.isScreenSmall = true;
    if (this.innerWidth < 500)
      this.isScreenXSmall = true;
  } else {
    this.isScreenSmall = false;
    this.isScreenXSmall = false;
  }

}

  constructor(
    private _authorizeService: AuthorizeService,
    private _customerService: CustomerService,
    private formBuilder: FormBuilder) {
        this._authorizeService.user$.subscribe(user => {
            this.custId = user?.customerId;
          });

          this.initializeForms();
  }

    ngOnInit() {
      if (localStorage.getItem('theme') == "light") {
        this.optionsTheme = 'options-light';
    } else {
        this.optionsTheme = 'options-dark';
    }

        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 770) {
          this.isScreenSmall = true;
          if (this.innerWidth < 500)
            this.isScreenXSmall = true;
        } else {
          this.isScreenSmall = false;
          this.isScreenXSmall = false;
        }

        this.customerTanksSelect$ = this._customerService.getCustomerTanks$(this.custId!);
        
      this.customerTanksSelect$.subscribe((tanks: string | any[]) => {
        if (tanks.length > 6) {
          this.showTankSelect = true;
          this.selectedTankId = tanks[0].tankId;
          this.tankSelectForm.controls['tankIdValue'].setValue(this.selectedTankId);
          this._customerService.getDashboardByTankId$(this.selectedTankId!).pipe(
            map((data: any) => {
              this.customerDashboard = data;
              this.customerTanks = data;
              return data;
            })
          ).subscribe((data: any) => this.chartData = data);
        }
        else {
          //GET all tanks < 10
          this._customerService.getCustomerDashboardById$(this.custId!).pipe(
            map((data: any) => {
              this.customerDashboard = data;
              this.customerTanks = data;
              return data;
            })
          ).subscribe((data: any) => this.chartData = data);
        }
      })
  
    }


    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    }
  
    selectOption(option: any) {
      this.selectedOption = option;
      this.dropdownOpen = false;
    }

  gallonsToggle(element: any) {
    this.isGallons = element.target.checked;
  }

  temperatureToggle(element: any) {
    this.isFahrenheit = element.target.checked;
  }

  initializeForms() {
    const startDate1 = new Date();
    const endDate1 = new Date();
    this.tankUsageForm = this.formBuilder.group({
        startDate: this.formBuilder.control(new Date(startDate1.setMonth((startDate1.getMonth() + 1) - 2))),
        endDate: this.formBuilder.control(new Date(endDate1)),
        dpStartDate: this.formBuilder.control({ day: startDate1.getDate(), month: startDate1.getMonth() + 1, year: startDate1.getFullYear() }),
        dpEndDate: this.formBuilder.control({ day: endDate1.getDate(), month: endDate1.getMonth() + 1, year: endDate1.getFullYear() }),
    })
    this.tankHistoryForm = this.formBuilder.group({
        startDate: this.formBuilder.control(new Date(startDate1)),
        endDate: this.formBuilder.control(new Date(endDate1)),
        dpStartDate: this.formBuilder.control({ day: startDate1.getDate(), month: startDate1.getMonth() + 1, year: startDate1.getFullYear() }),
        dpEndDate: this.formBuilder.control({ day: endDate1.getDate(), month: endDate1.getMonth() + 1, year: endDate1.getFullYear() }),
    })

    this.tankSelectForm = this.formBuilder.group({
      tankIdValue: this.formBuilder.control(0)
    })
  }


  onStartDateChange(newDate: NgbDateStruct) {
    this.startDate = newDate;
    this.setMaxEndDate();
  }

  setMaxEndDate() {
    if (this.startDate) {
        const newMaxEndDate = new Date(this.startDate.year, this.startDate.month + 1, this.startDate.day);
        this.tankUsageForm.controls['dpEndDate'].setValue({ day: newMaxEndDate.getDate(), month: newMaxEndDate.getMonth(), year: newMaxEndDate.getFullYear() });
    }
}

  selectTank2(option: any) {
    this.dropdownOpen = false;
    this.selectOption = option;

    this.selectedTankId = option.tankId;
    this._customerService.getDashboardByTankId$(option.tankId).pipe(
      map((data: any) => {
        this.customerDashboard = data;
        this.customerTanks = data;
        const newDate = new Date();
        this.tankUsageForm.controls['dpStartDate'].setValue({ day: newDate.getDate(), month: newDate.getMonth() - 2, year: newDate.getFullYear() });
        this.tankUsageForm.controls['dpEndDate'].setValue({ day: newDate.getDate(), month: newDate.getMonth() + 1, year: newDate.getFullYear() });
        this.tankHistoryForm.controls['dpStartDate'].setValue({ day: newDate.getDate(), month: newDate.getMonth() - 2, year: newDate.getFullYear() });
        this.tankHistoryForm.controls['dpEndDate'].setValue({ day: newDate.getDate(), month: newDate.getMonth() + 1, year: newDate.getFullYear() });
        return data;
      })
    ).subscribe((data: any) => this.chartData = data);
  }

  selectTank($event: any) {
    this.selectedTankId = $event.target.value;
    this._customerService.getDashboardByTankId$($event.target.value).pipe(
      map((data: any) => {
        this.customerDashboard = data;
        this.customerTanks = data;
        const newDate = new Date();
        this.tankUsageForm.controls['dpStartDate'].setValue({ day: newDate.getDate(), month: newDate.getMonth() - 2, year: newDate.getFullYear() });
        this.tankUsageForm.controls['dpEndDate'].setValue({ day: newDate.getDate(), month: newDate.getMonth() + 1, year: newDate.getFullYear() });
        this.tankHistoryForm.controls['dpStartDate'].setValue({ day: newDate.getDate(), month: newDate.getMonth() - 2, year: newDate.getFullYear() });
        this.tankHistoryForm.controls['dpEndDate'].setValue({ day: newDate.getDate(), month: newDate.getMonth() + 1, year: newDate.getFullYear() });
        return data;
      })
    ).subscribe((data: any) => this.chartData = data);
  }

  //Donut chart settings
  propaneLevelChartLabels = ["Total - Level", "Tank Level"];
  usageChartLabels = ["","Usage"];

  donutPieChartOptions = {
    responsive: true,
    animation: {
      animateScale: true,
      animateRotate: true
    },
    lables: {
        visible: false
    },
    legend: {
        display: false
    },
  };

  donutPieChartColors = [
    {
      backgroundColor: [
        'rgba(54, 162, 235, 0.2)', 
        'rgba(230, 245, 255, 0.2)'
      ],
      borderColor: [
        'rgba(54, 162, 235, 1)', 
        'rgba(230, 245, 255, 1)'
      ]
    }
  ];

  //Line chart settings:
  lineChartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    legend: {
      display: false
    },
    elements: {
      point: {
        radius: 0
      }
    }
  };

  lineChartColors = [
    {
      borderColor: 'rgba(45, 85, 255, 1)'
    }
  ];
  //End Line chart

  //Bar chart settings
  barChartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    legend: {
      display: false
    },
    elements: {
      point: {
        radius: 0
      }
    }
  };

  barChartColors = [
    {
      backgroundColor: [
        'rgba(54, 162, 235, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(54, 162, 235, 0.2)'
      ],
      borderColor: [
        'rgba(54, 162, 235, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(54, 162, 235, 1)'
      ]
    }
  ];
  //End Bar chart


  submitUsage(tank: any) {
    var startDate = this.tankUsageForm.controls["dpStartDate"].value;
        var endDate = this.tankUsageForm.controls["dpEndDate"].value;
        var selectedStartDate = new Date(startDate.year, startDate.month, startDate.day);
        var selectedEndDate = new Date(endDate.year, endDate.month, endDate.day);
        this.isLoading = true;
        this._customerService.getUsagesLevelsByDateRange$(tank.tankId, formatDate(selectedStartDate, 'MM-dd-yyyy', 'en-US'), formatDate(selectedEndDate, 'MM-dd-yyyy', 'en-US')).pipe(
            map((data: any) => {
                tank.propaneLevelPercentages = data.propaneLevelPercentages;
                tank.propaneChartLabels = data.propaneChartLabels;
                tank.usageLevelLitres = data.usageLevelLitres;
                tank.usageLevelGallons = data.usageLevelGallons;
                tank.usageLevelChartLabels = data.usageLevelChartLabels;
                return data;
            })
        ).subscribe((data: any) => this.chartData = data);
        this.isLoading = false;
  }

}
